import React from "react";
import { convertDateFormat } from "../../utils/dateUtils";
import { HIDE_LOADER, SHOW_LOADER, TOGGLE_NOTIFY_POPUP } from "../mdae-common-reducer";
import { CASE_SEARCH_TYPES, getCaseSearchCriteriaMappings } from "./constants";
import {
  RESET_AUTOCOMPLETE_DATA,
  SET_CASE_SEARCH_LIST_DATA,
  TOGGLE_CASE_SEARCH_LIST_POPUP,
  caseSearchCriteriaDatagridKeyExpr,
} from "./reducers/case-search-reducer";
import { KEY_INFORMATION_CASE_SEARCH } from "./services/case-search-for-key-information";
import { callOperation } from "async-ops";
import { NOTIFY_POPUP_TYPES } from "../common_widgets/notify-popup";
import { TOGGLE_ADD_CASE_TO_ROUND_POPUP } from "../../pages/external-audit/reducers/external-audit-reducer";
import { showNotifyPopup } from "../common-functions";
export const totalIdentifierMatchedWeightColumnName = "totalIdentifierMatchedWeight";
export const totalIdentifierMatchedCountColumnName = "totalIdentifierMatchedCount";

export const toggleCaseSearchListPopupVisible = (
  dispatch,
  isVisible,
  caseSearchType?
) => {
  dispatch({
    type: TOGGLE_CASE_SEARCH_LIST_POPUP,
    data: {
      isCaseSearchListPopupVisible: isVisible,
      caseSearchType: caseSearchType,
    },
  });
};
export const toggleAddCaseToRoundPopupVisible = (dispatch, isVisible) => {
  dispatch({
    type: TOGGLE_ADD_CASE_TO_ROUND_POPUP,
    data: {
      isAddCaseToRoundPopupVisible: isVisible,
    },
  });
};
export const updateCaseFoundList = (
  caseFoundList,
  eaCaseListData,
  caseSearchCriteraList: any[],
  claimType,
  eaAuditType,
  dispatch
) => {
  let caseSearchList = [];
  let eaCaseList = eaCaseListData[0]?.caseList;
  const {
    caseSearchCriteriaFiedMapperObject: ocrResultToCaseSearchTitlesMatching,
  } = getCaseSearchCriteriaMappings(claimType, eaAuditType);
  caseFoundList?.forEach((currentCase) => {
    const serviceFromDate = currentCase[ocrResultToCaseSearchTitlesMatching.service_from_date.caseFoundKeyExpr];
    const serviceToDate = currentCase[ocrResultToCaseSearchTitlesMatching.dos.caseFoundKeyExpr];
    const dischargeDate = currentCase[ocrResultToCaseSearchTitlesMatching.discharge_date.caseFoundKeyExpr];
    const dob = currentCase[ocrResultToCaseSearchTitlesMatching.dob.caseFoundKeyExpr];
    currentCase[ocrResultToCaseSearchTitlesMatching.service_from_date.caseFoundKeyExpr] = convertDateFormat(serviceFromDate, "MM/DD/YYYY");
    currentCase[ocrResultToCaseSearchTitlesMatching.dos.caseFoundKeyExpr] = convertDateFormat(serviceToDate, "MM/DD/YYYY");
    currentCase[ocrResultToCaseSearchTitlesMatching.discharge_date.caseFoundKeyExpr] = convertDateFormat(dischargeDate, "MM/DD/YYYY");
    currentCase[ocrResultToCaseSearchTitlesMatching.dob.caseFoundKeyExpr] = convertDateFormat(dob, "MM/DD/YYYY");

    const criteria = caseSearchCriteraList.find(
      (x) =>
        x[caseSearchCriteriaDatagridKeyExpr] ===
        currentCase[caseSearchCriteriaDatagridKeyExpr]
    );
    let totalIdentifierMatchedWeight = 0;
    let totalIdentifierMatchedCount = 0;
    if (criteria) {
      for (const [key, value] of Object.entries(criteria)) {
        const identifierObject = Object.keys(
          ocrResultToCaseSearchTitlesMatching
        )
          .filter((x) => ocrResultToCaseSearchTitlesMatching[x].keyExpr === key)
          .map((x) => ocrResultToCaseSearchTitlesMatching[x])[0];

        if (identifierObject && value) {
          let valueToCompare = value;
          if (valueToCompare instanceof Date)
            valueToCompare = convertDateFormat(valueToCompare, "MM/DD/YYYY");
          else if (typeof valueToCompare === "string")
            valueToCompare = valueToCompare.trim();

          const isValueMatching =
            currentCase[identifierObject.caseFoundKeyExpr] === valueToCompare;
          if (isValueMatching) {
            totalIdentifierMatchedWeight += identifierObject.caseListOrderWeight;
            totalIdentifierMatchedCount++;
            currentCase[identifierObject.caseFoundKeyExpr + "Found"] = true;
          }
        }
      }
    }
    currentCase[totalIdentifierMatchedWeightColumnName] = totalIdentifierMatchedWeight;
    currentCase[totalIdentifierMatchedCountColumnName] = totalIdentifierMatchedCount;
    let caseExists = eaCaseList?.filter((e) => e.caseId == currentCase.caseId);
    if (caseExists?.length == 0 || !caseExists) {
      caseSearchList.push(currentCase);
    }
  });
  return caseSearchList;
};
const updatecaseNotFoundList = (
  caseFoundList,
  keyInformationCaseSearchList
) => {
  let caseNotFoundList = [];
  keyInformationCaseSearchList.forEach((e) => {
    let caseExists = false;
    let caseList = caseFoundList.filter((c) => {
      if (!caseExists) {
        let caseFound = true;
        if (e.patientLastName) {
          caseFound =
            caseFound && c.patientLastName?.includes(e.patientLastName);
        }
        if (e.patientFirstName) {
          caseFound =
            caseFound && c.patientFirstName?.includes(e.patientFirstName);
        }
        if (e.medicalRecordNumber) {
          caseFound =
            caseFound && c.patientMRN?.includes(e.medicalRecordNumber);
        }
        if (e.patientDateofBirth) {
          caseFound =
            caseFound &&
            convertDateFormat(c.patientDateofBirth, "MM/DD/YYYY") ==
              e.patientDateofBirth;
        }
        if (caseFound) {
          caseExists = true;
          return c;
        }
      }
    });
    if (caseList?.length == 0 && !caseExists) {
      caseNotFoundList.push(e);
    }
  });
  return caseNotFoundList;
};

export const searchCasesForKeyInformation = (
  dispatch,
  params,
  keyInformationCaseSearchList: any[],
  claimTypeCd: string,
  dosSearchType: string,
  auditPropertiesData,
  eaCaseListData,
  keyInfoFileUploaderInstance = null,
  templateType,
  isUseAdmitDate=false
) => {
  return new Promise<void>((resolve) => {
    if (keyInformationCaseSearchList.length > 0) {
      dispatch({ type: SHOW_LOADER });
      const caseSearchdata = {
        eaAuditId: auditPropertiesData.eaAuditId,
        eaAuditType: auditPropertiesData.eaAuditType,
        serviceFrom: convertDateFormat(auditPropertiesData.serviceFromDate),
        serviceTo: convertDateFormat(auditPropertiesData.serviceToDate),
        dosSearchType: dosSearchType,
        claimTypeCd: claimTypeCd,
        auditGroupId: auditPropertiesData.auditGroupId ?? 0,
        caseSearchType: CASE_SEARCH_TYPES.KEY_INFORMATION,
        keyInformationCaseSearchList,
        loadType: templateType,
        isUseAdmitDate:isUseAdmitDate
      };
      callOperation(KEY_INFORMATION_CASE_SEARCH, caseSearchdata).then(function(
        response
      ) {
        if (response) {  
          if (response.caseListData.message) {
            showNotifyPopup(dispatch, response?.caseListData?.message);
            resolve();
            return;
          }    
          let caseFoundList = updateCaseFoundList(
            response.caseListData,
            eaCaseListData,
            keyInformationCaseSearchList,
            claimTypeCd,
            auditPropertiesData.eaAuditType,
            dispatch
          );
          let caseNotFoundList = updatecaseNotFoundList(
            caseFoundList,
            keyInformationCaseSearchList
          );
          dispatch({
            type: SET_CASE_SEARCH_LIST_DATA,
            data: {
              caseFoundList: caseFoundList,
              caseNotFoundList: caseNotFoundList,
            },
          });
          if (keyInfoFileUploaderInstance) keyInfoFileUploaderInstance.reset();
          dispatch({ type: HIDE_LOADER });
          resolve();
        }
      });
    } else {
      dispatch({
        type: SET_CASE_SEARCH_LIST_DATA,
        data: {
          caseFoundList: [],
          caseNotFoundList: [],
        },
      });
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          visible: true,
          contentHtml: () => {
            return <div>Please enter valid case search criteria.</div>;
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
          closeButtonText: "OK",
          width: 470,
          height: 250,
        },
      });
      if (keyInfoFileUploaderInstance) keyInfoFileUploaderInstance.reset();
      resolve();
    }
  });
};

export const resetCaseFoundList = (dispatch) =>{
  dispatch({
    type: SET_CASE_SEARCH_LIST_DATA,
    data: {
      caseFoundList: [],
      caseNotFoundList: [],
    },
  });
}

export const resetAutocompleteData = (dispatch) =>{
  dispatch({
    type: RESET_AUTOCOMPLETE_DATA,
  });
}

export const getHeaderColumnWithNote = (displayAlias, note) => {
  return (
    <>
      <span>{displayAlias}{" "}</span>
      <i
        title={note}
        className="img-circle fa fa-info-circle audit-info-circle"
      ></i>
    </>
  );
};

